
import {Component, Vue} from 'vue-property-decorator'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import CompanyInfo from '@/model/modules/CompanyInfo'
import CourierInfo from '@/model/modules/CourierInfo'
import CompanyService from '@/service/modules/CompanyService'
import CourierService from '@/service/modules/CourierService'

@Component
export default class CourierEditor extends Vue {
  item: CourierInfo = new CourierInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any
  companyOptions: CompanyInfo[] = []

  showEditor(item: CourierInfo, saveSuccessCallback: any) {
    this.refreshCompanyOptions()
    this.item = JSON.parse(JSON.stringify(item))
    this.saveSuccessCallback = saveSuccessCallback
    this.showState = true
  }

  refreshCompanyOptions() {
    CompanyService.list({}, 0, 99999)
      .then((result: BasePageableInfo<CompanyInfo>) => {
        this.companyOptions = result.dataList
      })
  }

  saveEditor() {
    this.savingState = true
    if (this.item.id === 0) {
      delete this.item.id
    }
    CourierService.save(this.item)
      .then(() => {
        this.$alert('保存数据', '保存成功', {
          confirmButtonText: '确定'
        })
        this.savingState = false
        this.showState = false
        this.saveSuccessCallback()
      })
  }
}
